var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useEffect, useState, useRef } from 'react';
import { green, red } from '@mui/material/colors';
import { Box, CircularProgress, Fab, Tooltip } from '@mui/material';
import ContentIcon from './ContentIcon';
import { wait } from '../../utils/utils';
var ProgressFab = function (props) {
    var _a = props.processing, processing = _a === void 0 ? false : _a, _b = props.success, success = _b === void 0 ? false : _b, _c = props.error, error = _c === void 0 ? false : _c, _d = props.disabled, disabled = _d === void 0 ? false : _d, _e = props.color, color = _e === void 0 ? 'default' : _e, sx = props.sx, _f = props.size, size = _f === void 0 ? 'medium' : _f, _g = props.tooltip, tooltip = _g === void 0 ? '' : _g, _h = props.displayPosition, displayPosition = _h === void 0 ? { top: 0, left: 0 } : _h, successIcon = props.successIcon, errorIcon = props.errorIcon, delay = props.delay, children = props.children, onClick = props.onClick, onDelay = props.onDelay;
    var getProgressSize = function (buttonSize) {
        if (buttonSize === 'small')
            return 52;
        if (buttonSize === 'medium')
            return 60;
        return 68;
    };
    var _j = useState(getProgressSize(size)), progressSize = _j[0], setProgressSize = _j[1];
    var timerRef = useRef(null);
    var onDoubleClick = function () { return false; };
    var buttonSx = __assign(__assign({}, (success && {
        bgcolor: green[500],
        '&:hover': {
            bgcolor: green[700],
        },
    })), (error && {
        bgcolor: red[500],
        '&:hover': {
            bgcolor: red[700],
        },
    }));
    useEffect(function () {
        setProgressSize(getProgressSize(size));
    }, [size]);
    useEffect(function () {
        if (error || success) {
            if (delay && onDelay) {
                void wait(delay, onDelay).then(function (id) {
                    timerRef.current = id;
                });
            }
        }
    }, [error, success]);
    return (React.createElement(Box, { sx: __assign({ position: 'fixed' }, displayPosition) },
        React.createElement(Tooltip, { title: tooltip, arrow: true },
            React.createElement("div", null,
                React.createElement(Fab, { color: color, sx: sx !== null && sx !== void 0 ? sx : buttonSx, size: size, disabled: disabled, onClick: onClick, onDoubleClick: onDoubleClick },
                    React.createElement(ContentIcon, { success: success, successIcon: successIcon, error: error, errorIcon: errorIcon }, children)))),
        processing && (React.createElement(CircularProgress, { size: progressSize, sx: {
                color: green[500],
                position: 'absolute',
                top: -6,
                left: -6,
                zIndex: 1,
            } }))));
};
ProgressFab.defaultProps = {
    processing: false,
    success: false,
    error: false,
    disabled: false,
    color: 'default',
    sx: undefined,
    size: 'medium',
    tooltip: '',
    displayPosition: { top: 0, left: 0 },
    successIcon: undefined,
    errorIcon: undefined,
    delay: undefined,
    onDelay: undefined,
};
export default ProgressFab;
//# sourceMappingURL=ProgressFab.js.map